import { dlTrackEvent } from 'components/dataLayer/dataLayer'
import { SubTitleAge } from 'components/legal-age/components/style/text'
import { TitleTriviaQr, DescriptionTriviaQr } from 'views/trivia-qr/styles/styled.components'

const Arrow = ({ color }: { color?: string }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="10" fill="#005943" />
      <path
        d="M11.3594 5.39062L15.6094 9.64062L15.9531 10L15.6094 10.3594L11.3594 14.6094L10.6406 13.8906L14.0312 10.5H4V9.5H14.0312L10.6406 6.10938L11.3594 5.39062Z"
        fill={color ?? 'white'}
      />
    </svg>
  )
}

const ArrowWhite = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="10" fill="white" />
      <path
        d="M11.3594 5.39062L15.6094 9.64062L15.9531 10L15.6094 10.3594L11.3594 14.6094L10.6406 13.8906L14.0312 10.5H4V9.5H14.0312L10.6406 6.10938L11.3594 5.39062Z"
        fill="#005943"
      />
    </svg>
  )
}

export const languageES = {
  legalage: {
    title: ' ',
    imageType: 'png'
  },
  agegate: {
    title: ' ',
    description: (
      <div className="w-full flex flex-col items-center justify-center gap-3">
        <img
          className=""
          src={`${AZURE_BASE_URL}/codigo_indio_agegate_portada.webp`}
          alt="Código Indio Agegate Portada"
        />
        <SubTitleAge className="text-center">
          {' '}
          <span style={{ fontFamily: 'Bebas Neue', fontSize: '32px' }}>¿Eres mayor de edad?</span>
          <br /> Por favor, Ingresa tu año de nacimiento.
        </SubTitleAge>
      </div>
    )
  },
  signup: {
    title: 'Bienvenido',
    description:
      'Ahora eres parte del equipo. Revisa tus correos para comenzar a registrar tus latas para completar la colección. Consigue las 26 latas de Amstel Ultra y descubre los mensajes de Rafa Nadal.',
    welcome: {
      description: (
        <>Te enviamos un código de 6 dígitos a tu correo electrónico EMAIL para que lo ingreses y valides tu cuenta.</>
      ),
      description2: <> </>,
      description3: (
        <>
          <b>¿No te llegó ningún correo?</b> <br /> Intentémoslo de nuevo
        </>
      ),
      'button-resend': <span className="mt-5">Da clic aquí para reenviarlo.</span>
    }
  },
  start: {
    signup: 'REGÍSTRATE CON CORREO',
    signin: 'ÉNTRALE CON CORREO',
    social: 'ENTRA CON:',
    title: {
      html: (
        <div className="flex-1 w-full py-2 flex flex-col items-center justify-center">
          <img src={`${AZURE_BASE_URL}/codigo-indio_portada_login.webp`} className="w-full max-w-sm" alt="background" />
        </div>
      )
    },
  },
  home: {
    title: (
      <span className="bebasneue" style={{ color: '#008065' }}>
        ¿QUÉ quieres hacer?
      </span>
    ),
    description: '¡Complete sus datos!',
    popup: {
      six: {
        mobile: `${AZURE_BASE_URL}/popups/popup-2-mobile.webp`,
        desktop: `${AZURE_BASE_URL}/popups/popup-2-desktop.webp`,
        'desktop-1500': `${AZURE_BASE_URL}/popups/popup-2-desktop-1440.webp`,
        'desktop-1920': `${AZURE_BASE_URL}/popups/popup-2-desktop-1920.webp`
      }
    }
  },
  profile: {
    form: {
      information: {
        firstname: {
          label: '¿CÓMO TE LLAMAS?',
          placeholder: 'Pon tu nombre aquí'
        },
        lastname: {
          placeholder: 'Pon tu apellido aquí'
        },
        nickname: {
          label: 'APODO',
          placeholder: '¿Como te gusta que te llamen?'
        },
        gender: {
          label: '¿Cómo te identificas?'
        }
      }
    },
    information: 'DATOS PERSONALES',
    address: 'DIRECCIÓN',
    contact: 'CONTACTO',
    button: 'IR A VER LAS TRIVIAS',
    identification: {
      nav: 'MI ROCK ID',
      title: 'ROCK ID',
      button: 'DESCARGAR ROCK ID',
      label: 'Mi ROCK ID',
      name: 'ROCK ID'
    },
    view: {
      contact: {
        notFound: '(vacío)'
      },
      history: {
        acquired: 'canjeado'
      }
    },
    coupon: {
      activate: 'ACTIVAR CUPÓN',
      active: 'Ver cupón activo',
      used: 'cupón usado',
      popup: {
        description: 'Estás a punto de activar tu cupón para mostrar en el módulo de canje.',
        warning: (
          <>
            Recuerda que este cupón es válido para usarlo <span>una sola vez</span> y tendrás unicamente{' '}
            <span>15 minutos</span> para hacerlo.
          </>
        ),
        sure: '¿Seguro que quieres activarlo ahora?',
        staff: <>Ahora acércate al módulo de canje y muestra tu pantalla a la persona que te esté atendiendo.</>,
        spinner: <span className="profile__history__popup__coupon__loader"></span>
      }
    },
    state: 'MIS PREMIOS',
    stateLabel: 'Mis premios'
  },
  config: {
    prizes: '/trivias'
  },
  congrats: {
    range: {
      title: 'NUEVO LOGRO DESBLOQUEADO',
      description: <></>,
      description2: (
        <>
          Felicitaciones, has desbloqueado nuevos <br /> premios y obtienes más chances de ganar.
        </>
      )
    }
  },
  endroute: {
    title: (
      <>
        ¡Lo sentimos! <br /> Esto es solo <br /> para mayores
      </>
    ),
    description: 'Vuelve cuando sea más grande.'
  },
  referrals: {
    modal: {
      content: (
        <>
          <div className="flex gap-4 items-center">
            <img src={`${AZURE_BASE_URL}/referrals-modal-icon-1.webp`} alt="icon" loading="lazy" />
            <p>
              <span>
                <b>Completa tu perfil</b>{' '}
              </span>
              <br /> Termina de completar tu cuenta con tus datos personales.
            </p>
          </div>
          <div className="flex gap-4 items-center">
            <img src={`${AZURE_BASE_URL}/referrals-modal-icon-2.webp`} alt="icon" loading="lazy" />
            <p>
              <span>
                <b>Comparte tu código</b>
              </span>{' '}
              <br />
              Invita a amigos a registrarse utilizando tu código referido y gana puntos extra por cada invitado que se
              una a la plataforma.
            </p>
          </div>
          <div className="flex gap-4 items-center">
            <img src={`${AZURE_BASE_URL}/referrals-modal-icon-3.webp`} alt="icon" loading="lazy" />
            <p>
              <span>
                <b>Participa por el premio especial</b>
              </span>{' '}
              <br />
              Al terminar la “temporada” ganará el usuario con la mayor cantidad de registros referidos acumulados.
            </p>
          </div>
        </>
      )
    },
    rules: {
      list: (
        <>
          <div className="w-full flex gap-5 justify-center items-center">
            <Arrow />
            <div className="flex-1">
              <p className="font-normal roboto text-base">Lorem ipsum dolor sit amet.</p>
            </div>
          </div>
          <div className="w-full flex gap-5 justify-center items-center">
            <Arrow />
            <div className="flex-1">
              <p className="font-normal roboto text-base">
                Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget. Aenean massa.
              </p>
            </div>
          </div>
          <div className="w-full flex gap-5 justify-center items-center">
            <Arrow />
            <div className="flex-1">
              <p className="font-normal roboto text-base">
                Lorem ipsum dolor sit amet, adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis
                natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies
                nec, pellentesque eu, pretium quis, sem.
              </p>
            </div>
          </div>
        </>
      )
    },
    code: {
      share: 'Este es tu código',
      dynamic: {
        content: (
          <>
            <div className="referrals__code__dynamic__content__list-item">
              <Arrow color="white" />
              <div className="flex-1">
                <p className="">Lorem ipsum dolor sit amet, consectetuer adipiscing elit.</p>
              </div>
            </div>
            <div className="referrals__code__dynamic__content__list-item">
              <Arrow color="white" />
              <div className="flex-1">
                <p className="">Cum sociis natoque penatibus et magnis dis parturient montes.</p>
              </div>
            </div>
            <div className="referrals__code__dynamic__content__list-item">
              <Arrow color="white" />
              <div className="flex-1">
                <p className="">Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu.</p>
              </div>
            </div>
          </>
        )
      }
    }
  },
  trivias: {
    congrats: '¡FELICIDADES',
    exit: {
      title: 'Si cancelas ahora pierdes y tiene que volver a empezar',
      subtitle: '¿Seguro que vamos por este camino?'
    },
    exchange: {
      description: 'OBTUVISTE',
      button: {
        text: 'cOMPLETAR MIS DATOS',
        url: '/profile/phone'
      }
    },
    triviaQr: {
      register: {
        title: (
          <>
            ¡CONTESTA <span style={{ color: '#D0B787' }}>Y GANA</span>!
          </>
        ),
        typeImage: 'webp',
        html: (
          <div className="h-full flex justify-center items-center">
            <div className="flex flex-col gap-10">
              <TitleTriviaQr>
                ¡CONTESTA <span style={{ color: '#D0B787' }}>Y GANA</span>!
              </TitleTriviaQr>
              <img
                style={{ width: '90%' }}
                className="mx-auto"
                src={`${AZURE_BASE_URL}/trivia-qr-card-id.webp`}
                alt="card id"
              />
              <div>
                <DescriptionTriviaQr className="">¿Ya tienes tu ROCK ID?</DescriptionTriviaQr>
                <p
                  style={{
                    color: '#FFF',
                    textAlign: 'center',
                    fontFamily: 'Roboto',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    lineHeight: 'normal'
                  }}
                >
                  SI NO CÓRRELE A REGISTRARTE PARA <br /> PODER PARTICIPAR
                </p>
              </div>
            </div>
          </div>
        )
      },
      late: {
        title: (
          <>
            ¡UPS! <br /> YA ES TARDE{' '}
          </>
        ),
        description: (
          <>
            Ya no quedan trivias disponibles para este horario. Estate atento a los próximos bloques para poder
            participar.
            <br />
            <br />
            Recuerda que las trivias se activan cada 2 horas en los bloques de: 4pm - 6pm - 8pm - 10pm.
          </>
        ),
        button: {
          text: 'VOLVER AL HOME',
          link: '/home'
        }
      }
    },
    modal: {
      title: (
        <>
          ¿Estás seguro que <br /> quieres salir?
        </>
      ),
      description: (
        <>
          Si cancelas ahora se perderá tu progreso <br /> y tendrás que volver a empezar. <br /> <br />{' '}
          <span className="font-light">¿Segurisimo que vamos por este camino?</span>
        </>
      )
    },
    'not-found': <>No hay trivias disponibles.</>
  },
  tivias: {
    challenge: {
      modal: {
        description: '¿Seguro que quieres empezar a jugar? Una vez que des clic no hay vuelta atrás.'
      }
    }
  },
  trivia: {
    exit: {
      accept: 'Si, claro',
      cancel: 'NO, VOLVER'
    }
  },
  survey: {
    title: {
      6: <img src={`${AZURE_BASE_URL}/survey/title-8.webp`} alt="Trivia Title" />
    },
    button: 'RESPONDER',
    onboarding: {
      html: (
        <div className='px-6 w-full space-y-6'>
          <img src={`${AZURE_BASE_URL}/wifi/vl26_portada.webp`} />
          <div className='w-full flex items-center flex-col'>
            <h2>¿Aún no tienes tu GUERRRO ID?</h2>
            <p>Regístrate y participa en la trivia.</p>
          </div>
        </div>
      ),
      button: "Empezar"
    },
    cover: {
      html: {
        5: (
          <div className='px-6 w-full space-y-6'>
            <img src={`${AZURE_BASE_URL}/survey/portada_confimracion_img_1.webp`} className='w-3/4 mx-auto' />
            <div className='w-full flex items-center flex-col'>
              <h2>
                PARTICIPARÁS POR<br />
                OPORTUNIDAD DE GANAR BOLETOS<br />
                PARA VIVE LATINO 26.
              </h2>
              <p>SI INICIAS LA TRIVIA YA NO PUEDES VOLVER.</p>
            </div>
          </div>
        ),
        6: (
          <div className='px-6 w-full space-y-6 flex-1 flex flex-col justify-center'>
            <img src={`${AZURE_BASE_URL}/survey/portada_confimracion_img_3.webp`} className='w-3/4 mx-auto' />
            <div className='w-full flex items-center flex-col gap-2'>
              <p>Estás a punto de participar y obtener: Chance de girar la rueda de la fortuna.</p>
              <b>¿Segurísimo que quieres empezar a jugar?<br />una vez que des clic no hay vuelta atrás.</b>
            </div>
          </div>
        )
      },
      button: "¡Jalo!"
    },
    exchange: {
      button: {
        dontShowButtons: false,
      },
      title: {
        6: <img src={`${AZURE_BASE_URL}/survey/title-win-8.webp`} alt="Trivia Title" />
      },
      description: {
        6: <></>
      }
    }
  },
  error: {
    505: {
      title: (
        <>
          ¡OH NO!
          <br />
          FALLASTE{' '}
        </>
      ),
      button: {
        text: 'VOLVER A INTENTAR'
      }
    },
    509: {
      title: '¡QUE PENA!',
      description: (
        <>
          Ya no quedan trivias disponibles para este horario. Estate atento a los próximos bloques para poder
          participar.
          <br />
          <br />
          Recuerda que las trivias se activan cada 2 horas en los bloques de: 4pm - 6pm - 8pm - 10pm.
        </>
      )
    },
    512: {
      title: (
        <>
          ¡UPS!
          <br />
          YA ES TARDE
        </>
      ),
      description: (
        <>
          Ya no quedan trivias disponibles para este horario. Estate atento a los próximos bloques para poder
          participar.
          <br />
          <br />
          Recuerda que las trivias se activan cada 2 horas en los bloques de: 4pm - 6pm - 8pm - 10pm.
        </>
      ),
      button: {
        text: 'VOLVER A HOME'
      }
    },
    auth: {
      'email-already-in-use': {
        title: 'Este mail ya se encuentra registrado en la base de datos de Heineken México'
      }
    },
    10: {
      title: '¡UPS! El código OTP es inválido'
    },
    1108: {
      button: {
        text: 'Ver los diseños ganadores',
        url: '/album/redirect/Foto/ranking'
      }
    },
    7001: {
      title: 'YA TIENES ESE VASO',
      description: 'Prueba con otro diferente, checa tu colección para ver cuáles ya tienes.'
    }
  },
  otp: {
    received: '¿No la recibiste?'
  },
  email: {
    recovery:
      'Ya te enviamos el correo con las instrucciones para resetear tu contraseña. Revisa tus correos para poder volver a ingresar.',
    send: '¿No te llegó ningún correo?',
    resend: 'Intentémoslo de nuevo.'
  },
  album: {
    title: 'DINÁMICAS',
    notFound: 'No hay retos disponibles por el momento, estate atento a nuestras nuevas dinámicas.'
  },
  social: {
    loader: {
      title: 'ESTAMOS VALIDADO TU DISEÑO'
    },
    imgUpload: 'Espera mientras revisamos tu imagen.',
    Foto: {
      howToParticipate: {
        subtitle: 'SUBE TU DISEÑO Y PARTICIPA',
        list: (
          <ul className="flex-1 items-center justify-center flex-col flex w-full gap-3 pb-7">
            <li className="flex flex-row w-full gap-5">
              <img src={`${AZURE_BASE_URL}/social-howToParticipate-1.svg`} />
              <div className="flex-1 flex flex-col justify-center">
                <p
                  className="text-base font-normal"
                  style={{ fontFamily: 'Roboto', color: '#000000', lineHeight: '20px' }}
                >
                  <b className="text-lg font-bold" style={{ lineHeight: '20px' }}>
                    Completa tu perfil
                  </b>
                  <br />
                  Checa tener tus datos personales completos.
                </p>
              </div>
            </li>
            <li className="flex flex-row w-full gap-5">
              <img src={`${AZURE_BASE_URL}/social-howToParticipate-2.svg`} />
              <div className="flex-1 flex flex-col justify-center">
                <p
                  className="text-base font-normal"
                  style={{ fontFamily: 'Roboto', color: '#000000', lineHeight: '20px' }}
                >
                  <b className="text-lg font-bold" style={{ lineHeight: '20px' }}>
                    Crea tu diseño personalizado
                  </b>
                  <br />
                  Con el kit que se te proporciona tendrás que crear un diseño que te identifique.
                </p>
              </div>
            </li>
            <li className="flex flex-row w-full gap-5">
              <img src={`${AZURE_BASE_URL}/social-howToParticipate-3.svg`} />
              <div className="flex-1 flex flex-col justify-center">
                <p
                  className="text-base font-normal"
                  style={{ fontFamily: 'Roboto', color: '#000000', lineHeight: '20px' }}
                >
                  <b className="text-lg font-bold" style={{ lineHeight: '20px' }}>
                    Sube tu diseño
                  </b>
                  <br />
                  En formato JPG.
                </p>
              </div>
            </li>
            <li className="flex flex-row w-full gap-5">
              <img src={`${AZURE_BASE_URL}/social-howToParticipate-4.svg`} />
              <div className="flex-1 flex flex-col justify-center">
                <p
                  className="text-base font-normal"
                  style={{ fontFamily: 'Roboto', color: '#000000', lineHeight: '20px' }}
                >
                  <b className="text-lg font-bold" style={{ lineHeight: '20px' }}>
                    Contactaremos a los ganadores
                  </b>
                  <br />
                  Asegúrate de tener tu archivo vectorial listo (en Adobe Illustrator).
                </p>
              </div>
            </li>
            <li
              className="border border-dashed rounded-lg p-2 flex items-center gap-6 w-full"
              style={{ background: 'rgba(255, 229, 0, 0.08)', borderColor: '#AC9100' }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
                <rect width="56" height="56" rx="28" fill="white" />
                <path
                  d="M40.6362 35.4906L30.2509 17.3162C30.0244 16.9166 29.696 16.5843 29.2992 16.3531C28.9024 16.1218 28.4513 16 27.9921 16C27.5328 16 27.0817 16.1218 26.6849 16.3531C26.2881 16.5843 25.9597 16.9166 25.7332 17.3162L15.3479 35.4906C15.119 35.887 14.999 36.3368 15 36.7946C15.001 37.2523 15.123 37.7017 15.3537 38.097C15.5843 38.4924 15.9154 38.8198 16.3133 39.046C16.7113 39.2722 17.162 39.3892 17.6197 39.3851H38.3904C38.8459 39.3846 39.2933 39.2643 39.6876 39.0362C40.0819 38.8082 40.4093 38.4804 40.6369 38.0857C40.8644 37.6911 40.9842 37.2436 40.9841 36.7881C40.9839 36.3325 40.864 35.8851 40.6362 35.4906Z"
                  stroke="#AC9100"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M28.0054 23.807V28.9997"
                  stroke="#AC9100"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M28.0054 34.1924H28.0184"
                  stroke="#AC9100"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <p className="text-xs font-normal leading-normal" style={{ color: '#AC9100', fontFamily: 'Roboto' }}>
                Utilizar únicamente este{' '}
                <a
                  className="underline font-bold"
                  href="https://cdn-phcentral.azureedge.net/indio/dinamica/Gui%CC%81a%20para%20ilustrar%20Etiquetas%20INDIO-20240508T135630Z-001.zip"
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => {
                    dlTrackEvent('user_interaction', {
                      action: 'click',
                      element: 'Descarga Toolkit',
                      section: 'subir diseño'
                    })
                  }}
                >
                  kit de diseño
                </a>
              </p>
            </li>
          </ul>
        )
      },
      onBoarding: {
        rules: {
          list: (
            <>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal dinPro text-sm" style={{ color: '#040404' }}>
                    El diseño debe contener el logo de Indio.
                  </p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal dinPro text-sm" style={{ color: '#040404' }}>
                    Seguir las instrucciones del kit de diseño.
                  </p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal dinPro text-sm" style={{ color: '#040404' }}>
                    No incluir en el diseño: símbolos religiosos, niños, desnudos o que algo que pueda atentar contra
                    una propiedad intelectual! (alebrijes, asociaciones de danza cultural, marcas, productos o negocios
                    registrados)
                  </p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal dinPro text-sm" style={{ color: '#040404' }}>
                    Si el contenido es inapropiado se inactivará el usuario para que no pueda subir más contenido.
                  </p>
                </div>
              </div>
            </>
          )
        }
      },
      upload: {
        title: 'CARGAR DISEÑO',
        subtitle: 'Clic para subir diseño',
        warningPhoto: (
          <div
            className="border border-dashed rounded-lg p-2 flex items-center gap-6 w-full"
            style={{ background: 'rgba(255, 229, 0, 0.08)', borderColor: '#AC9100' }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
              <rect width="56" height="56" rx="28" fill="white" />
              <path
                d="M40.6362 35.4906L30.2509 17.3162C30.0244 16.9166 29.696 16.5843 29.2992 16.3531C28.9024 16.1218 28.4513 16 27.9921 16C27.5328 16 27.0817 16.1218 26.6849 16.3531C26.2881 16.5843 25.9597 16.9166 25.7332 17.3162L15.3479 35.4906C15.119 35.887 14.999 36.3368 15 36.7946C15.001 37.2523 15.123 37.7017 15.3537 38.097C15.5843 38.4924 15.9154 38.8198 16.3133 39.046C16.7113 39.2722 17.162 39.3892 17.6197 39.3851H38.3904C38.8459 39.3846 39.2933 39.2643 39.6876 39.0362C40.0819 38.8082 40.4093 38.4804 40.6369 38.0857C40.8644 37.6911 40.9842 37.2436 40.9841 36.7881C40.9839 36.3325 40.864 35.8851 40.6362 35.4906Z"
                stroke="#AC9100"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M28.0054 23.807V28.9997"
                stroke="#AC9100"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M28.0054 34.1924H28.0184"
                stroke="#AC9100"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p className="text-xs font-normal leading-normal" style={{ color: '#AC9100', fontFamily: 'Roboto' }}>
              Utilizar únicamente este{' '}
              <a
                className="underline font-bold"
                href="https://cdn-phcentral.azureedge.net/indio/dinamica/Gui%CC%81a%20para%20ilustrar%20Etiquetas%20INDIO-20240508T135630Z-001.zip"
                target="_blank"
                rel="noreferrer"
                onClick={() => {
                  dlTrackEvent('user_interaction', {
                    action: 'click',
                    element: 'Descarga Toolkit',
                    section: 'subir diseño'
                  })
                }}
              >
                kit de diseño
              </a>
            </p>
          </div>
        ),
        rules: {
          title: 'REGLAS PARA SUBIR TU DISEÑO',
          list: (
            <ul style={{ color: '#272727', fontSize: '14px', fontFamily: 'Roboto' }}>
              <li>
                <p className="flex gap-1">
                  <span>1.</span> El diseño debe contener el logo de Indio.
                </p>
              </li>
              <li className="my-3">
                <p className="flex gap-1">
                  <span>2.</span> Seguir las instrucciones del kit de diseño.
                </p>
              </li>
              <li>
                <p className="flex gap-1">
                  <span>3.</span> No incluir en el diseño: símbolos religiosos, niños, desnudos o que algo que pueda
                  atentar contra una propiedad intelectual.
                </p>
              </li>
            </ul>
          )
        },
        isReady: '¿ESTA OK ESTE DISEÑO?',
        buttonSubmit: 'CONFIRMAR',
        alreadyUploaded: {
          title: '¡VEEEEEEENGA!',
          description: (
            <>
              Sigue subiendo tus diseños y suma mas oportunidades de ganar.
              <br />
              <br />
              En caso de resultar ganador deberás tener tus datos de contacto completos y tu PSD ganador.
            </>
          ),
          button: {
            url: '/profile',
            text: 'COMPLETAR MIS DATOS'
          },
          button2: {
            url: '/album/redirect/Foto/upload',
            text: 'CARGAR OTRO'
          }
        },
        'ranking-subtitle': {
          completed: 'Este reto ya ha finalizado pero puedes ver los ganadores'
        }
      }
    },
    Card: {
      howToParticipate: {
        subtitle: 'PERSONALIZA TU ETIQUETA Y DESCÁRGALA',
        list: (
          <ul className="flex-1 items-center justify-center flex-col flex w-full gap-7 pb-7">
            <li className="flex flex-row w-full gap-5">
              <img src={`${AZURE_BASE_URL}/edit-icon.svg`} />
              <div className="flex-1 flex flex-col justify-center">
                <p
                  className="text-base font-normal"
                  style={{ fontFamily: 'Roboto', color: '#000000', lineHeight: '20px' }}
                >
                  <b className="text-lg font-bold" style={{ lineHeight: '20px' }}>
                    Personaliza tu etiqueta
                  </b>
                  <br />
                  Agrega un nombre o apodo a la etiqueta especial para hacerla tuya.
                </p>
              </div>
            </li>
            <li className="flex flex-row w-full gap-5">
              <img src={`${AZURE_BASE_URL}/upload-icon.svg`} />
              <div className="flex-1 flex flex-col justify-center">
                <p
                  className="text-base font-normal"
                  style={{ fontFamily: 'Roboto', color: '#000000', lineHeight: '20px' }}
                >
                  <b className="text-lg font-bold" style={{ lineHeight: '20px' }}>
                    Descarga tu nueva etiqueta
                  </b>
                  <br />
                  Tendrás la imagen de la botella con la etiqueta edición especial personalizada con tu nombre.
                </p>
              </div>
            </li>
          </ul>
        )
      },
      onBoarding: {
        rules: {
          list: (
            <>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal dinPro text-base" style={{ color: '#040404' }}>
                    El nombre ingresado puede contener 12 caracteres como máximo.
                  </p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal dinPro text-base" style={{ color: '#040404' }}>
                    No puede tener lenguaje ofensivo o mal sonante.
                  </p>
                </div>
              </div>
              <div className="w-full flex gap-5 justify-center">
                <Arrow />
                <div className="flex-1">
                  <p className="font-normal dinPro text-base" style={{ color: '#040404' }}>
                    Si el contenido es inapropiado el diseño se rechazara y no podrás volver a participar.
                  </p>
                </div>
              </div>
            </>
          )
        }
      },
      upload: {
        title: 'PERSONALIZA TU ETIQUETA',
        subtitle: 'Clic para cargar tu nombre',
        rules: {
          title: 'REGLAS PARA PERSONALIZAR TU ETIQUETA',
          list: (
            <ul style={{ color: '#272727', fontSize: '14px', fontFamily: 'Roboto' }}>
              <li>
                <p className="flex gap-1">
                  <span>1.</span> Agrega tu nombre o apodo a la etiqueta especial para hacerla tuya.
                </p>
              </li>
              <li className="my-3">
                <p className="flex gap-1">
                  <span>2.</span> El nombre que ingreses puede tener hasta 12 caracteres como máximo y no puede tener
                  lenguaje mal sonante.
                </p>
              </li>
              <li>
                <p className="flex gap-1">
                  <span>3.</span> Descarga la imagen final con tu etiqueta personalizada a tu móvil.
                </p>
              </li>
            </ul>
          )
        },
        alreadyUploaded: {
          icon: (
            <>
              <svg width="125" height="125" viewBox="0 0 125 125" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="62.084" cy="62.084" r="60.084" stroke="#FFCC71" strokeWidth="4" />
                <path d="M26 56L55 85L98 42" stroke="#FFCC71" strokeWidth="6" strokeLinecap="square" />
              </svg>
            </>
          ),
          description: 'Se ha agregado correctamente tu contenido.',
          button: {
            url: '/album/redirect/Card/profile',
            text: 'Ver mi contenido'
          },
          button2: {
            url: '/album/redirect/Card/ranking',
            text: 'Ver galería'
          },
          buttonBack: {
            text: 'CARGAR OTRA IMAGEN'
          }
        },
        buttons: {
          handler: 'Clic para cargar tu nombre',
          send: 'CONFIRMAR',
          ready: {
            button: 'CONFIRMAR',
            buttonCancel: 'NO, CARGAR NUEVAMENTE'
          }
        },
        canvasWidth: 1920,
        canvasHeight: 1920
      },
      title: 'PERSONALIZA TU ETIQUETA',
      maxLength: 12,
      placeholder: 'TU NOMBRE',
      example: {
        list: (
          <>
            <h3 className="album__card__example__list-title font-bold">Así quedaría la imagen final con tu frase</h3>
            <ul className="album__card__example__ul flex gap-3 flex-col">
              <li>
                Piensa bien que vas a escribir, usa tu nombre o apodo, o el nombre de alguien a quien quieras enviarle
                la imagen. Tienes 12 caracteres cómo máximo.
              </li>
              <li>
                <b>Esta no es una muestra de la lata de premio</b>, si no una imagen de referencia para que veas como
                queda la imagen generada en esta plataforma para el concurso.
              </li>
            </ul>
          </>
        )
      }
    }
  },
  collections: {
    popup: (
      <>
        <div>
          <h2 className="collections__popup__title">¿Cómo participar?</h2>
          <h4 className="collections__popup__subtitle">COLECCIONA LOS VASOS y gana</h4>
        </div>

        <ul className="flex-1 items-center justify-center flex-col flex w-full gap-3 pb-7 collections__popup__ul">
          <li
            className="border border-dashed rounded-lg p-2 flex items-center gap-6 w-full mt-4"
            style={{ background: 'rgba(255, 229, 0, 0.08)', borderColor: '#AC9100', marginBottom: '13px' }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
              <rect width="56" height="56" rx="28" fill="white" />
              <path
                d="M40.6362 35.4906L30.2509 17.3162C30.0244 16.9166 29.696 16.5843 29.2992 16.3531C28.9024 16.1218 28.4513 16 27.9921 16C27.5328 16 27.0817 16.1218 26.6849 16.3531C26.2881 16.5843 25.9597 16.9166 25.7332 17.3162L15.3479 35.4906C15.119 35.887 14.999 36.3368 15 36.7946C15.001 37.2523 15.123 37.7017 15.3537 38.097C15.5843 38.4924 15.9154 38.8198 16.3133 39.046C16.7113 39.2722 17.162 39.3892 17.6197 39.3851H38.3904C38.8459 39.3846 39.2933 39.2643 39.6876 39.0362C40.0819 38.8082 40.4093 38.4804 40.6369 38.0857C40.8644 37.6911 40.9842 37.2436 40.9841 36.7881C40.9839 36.3325 40.864 35.8851 40.6362 35.4906Z"
                stroke="#AC9100"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M28.0054 23.807V28.9997"
                stroke="#AC9100"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M28.0054 34.1924H28.0184"
                stroke="#AC9100"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p className="text-xs font-normal leading-normal" style={{ color: '#AC9100', fontFamily: 'Roboto' }}>
              Dinámica finalizada. Gracias guerreros.
            </p>
          </li>

          {/* 
          <li className="flex flex-row w-full gap-5">
            <img src={`${AZURE_BASE_URL}/perfil_icon.svg`} />
            <div className="flex-1 flex flex-col justify-center">
              <p
                className="text-base font-normal"
                style={{ fontFamily: 'Roboto', color: '#000000', lineHeight: '20px' }}
              >
                <b className="text-lg font-bold" style={{ lineHeight: '20px' }}>
                  Completa tu perfil
                </b>
                <br />
                Asegura de llenar tus datos personales en “Mi información”.
              </p>
            </div>
          </li>
          <li className="flex flex-row w-full gap-5">
            <img src={`${AZURE_BASE_URL}/invita-_icon.svg`} />
            <div className="flex-1 flex flex-col justify-center">
              <p
                className="text-base font-normal"
                style={{ fontFamily: 'Roboto', color: '#000000', lineHeight: '20px' }}
              >
                <b className="text-lg font-bold" style={{ lineHeight: '20px' }}>
                  Reúnete con otros guerreros
                </b>
                <br />
                Hagan equipo de 3 guerreros cómo máximo para iniciar la colección.
              </p>
            </div>
          </li> */}
          <li className="flex flex-row w-full gap-5">
            <img src={`${AZURE_BASE_URL}/scan-vaso_icon.svg`} />
            <div className="flex-1 flex flex-col justify-center">
              <p
                className="text-base font-normal"
                style={{ fontFamily: 'Roboto', color: '#000000', lineHeight: '20px' }}
              >
                <b className="text-lg font-bold" style={{ lineHeight: '20px' }}>
                  Colección DIGITAL
                </b>
                <br />
                Captura el código QR de los 25 vasos del Vive Latino para completar tu colección digital.
              </p>
            </div>
          </li>
          {/* <li className="flex flex-row w-full gap-5 pb-5 items-start">
            <img src={`${AZURE_BASE_URL}/coleccion-vaso_icon.svg`} />
            <div className="flex-1 flex flex-col justify-center">
              <p
                className="text-base font-normal"
                style={{ fontFamily: 'Roboto', color: '#000000', lineHeight: '20px' }}
              >
                <b className="text-lg font-bold" style={{ lineHeight: '20px' }}>
                  Busca el stand de INDIO para canjear la colección
                </b>
                <br />
                Los 3 guerreros deben de presentar su colección de 25 vasos tanto FÍSICOS así como DIGITALES de los primeros 5 equipos de guerreros en coleccionar los 25 vasos (digitales y físicos) y cada guerrero se lleva 1 hielera de Cerveza INDIO.
              </p>
            </div>
          </li> */}

        </ul>
      </>
    ),
    album: {
      cta: {
        text: 'Completar mis datos',
        link: '/profile/information'
      }
    },
    redeem: {
      congrats: {
        title: 'Vaso agregado a tu colección',
        button: 'Ir a ver la colección',
        url: '/collections'
      }
    },
    found: 'Total encontrados',
    'not-found': {
      card: {
        text: <>Encuéntra el vaso para desbloquear la tarjeta, ver su información y compartirla.</>,
      }
    },

  },
  wheelFortune: {
    rules: (
      <>
        <div className="w-full flex gap-5 justify-center">
          <Arrow />
          <div className="flex-1">
            <p className="font-normal roboto text-base">
              Para obtener chances de girar la rueda tienes que completar alguna actividad de la plataforma.
            </p>
          </div>
        </div>
        <div className="w-full flex gap-5 justify-center">
          <Arrow />
          <div className="flex-1">
            <p className="font-normal roboto text-base">
              Obtendrás 1 chance de girar la rueda por cada dinámica o actividad que completes exitosamente.
            </p>
          </div>
        </div>
        <div className="w-full flex gap-5 justify-center">
          <Arrow />
          <div className="flex-1">
            <p className="font-normal roboto text-base">
              Podrás obtener 1 chance cómo máximo de cada actividad por día.
            </p>
          </div>
        </div>
      </>
    ),
    title: <img src={`${AZURE_BASE_URL}/wheel/ruleta_titular_imagne_2x.webp`} className="wheel-title w-full" />,
    description: <></>
  },
  lineup: {},
  events: {
    map: {
      onboarding: {
        list: (
          <>
            <div className="w-full flex gap-5 justify-center">
              <ArrowWhite />
              <div className="flex-1">
                <p className="font-normal dinPro text-base">
                  Para empezar, necesitaremos que nos des permisos para acceder a tu ubicación, esto nos ayudará a
                  brindarte una mejor experiencia usando el mapa.
                </p>
              </div>
            </div>
            <div className="w-full flex gap-5 justify-center">
              <ArrowWhite />
              <div className="flex-1">
                <p className="font-normal dinPro text-base">
                  Podrás usar el mapa para ubicar puntos de interés dentro del campo del evento.
                </p>
              </div>
            </div>
            <div className="w-full flex gap-5 justify-center">
              <ArrowWhite />
              <div className="flex-1">
                <p className="font-normal dinPro text-base">
                  Utiliza la ubicación para pinnear en el parking tu coche.
                </p>
              </div>
            </div>
            <div className="w-full flex gap-5 justify-center">
              <ArrowWhite />
              <div className="flex-1">
                <p className="font-normal dinPro text-base">
                  Si no dispones de internet, podrás descargarlo en formato imagen con todos los puntos de interés.
                </p>
              </div>
            </div>
          </>
        )
      }
    }
  },
  groups: {
    start: {
      onboarding: {
        list: (
          <>
            <img src={`${AZURE_BASE_URL}/groups-header.png`} />
            <ul className="flex-1 items-center justify-center flex-col flex w-full gap-6 pb-7">
              <li className="flex items-start flex-row w-full gap-5">
                <img src={`${AZURE_BASE_URL}/groups-onboarding-2.svg`} className="w-12" />
                <div className="flex-1 flex flex-col justify-center">
                  <p className="font-normal dinPro text-base">
                    <b>Crea un grupo o sé parte de uno</b>
                    <br />
                    Forma tu propio grupo, dale un nombre y un perfil para empezar. También puedes participar formando
                    parte de un grupo al que te inviten.
                  </p>
                </div>
              </li>
              <li className="flex items-start flex-row w-full gap-5">
                <img src={`${AZURE_BASE_URL}/groups-onboarding-1.svg`} className="w-12" />
                <div className="flex-1 flex flex-col justify-center">
                  <p className="font-normal dinPro text-base">
                    <b>Invita a tus amigos y acumula puntos</b>
                    <br />
                    Invita a tus amigos a formar parte de tu grupo y empiecen a juntar puntos participando de dinámicas.
                  </p>
                </div>
              </li>
              <li className="flex items-start flex-row w-full gap-5">
                <img src={`${AZURE_BASE_URL}/groups-onboarding-3.svg`} className="w-12" />
                <div className="flex-1 flex flex-col justify-center">
                  <p className="font-normal dinPro text-base">
                    <b>Participa por el premio especial</b>
                    <br />
                    Al terminar la “temporada” ganará el grupo que haya acumulado la mayor cantidad de puntos en las
                    distintas.
                  </p>
                </div>
              </li>
            </ul>
          </>
        )
      }
    }
  },
  wifi: {
    buttonId: 'QUIERO MI ROCKID'
  },
  wheel: {
    congrats: {
      win: {
        button: {
          text: 'Ir al rock id',
          url: '/profile/identificacion'
        },
        title: <img src={`${AZURE_BASE_URL}/good-prize-congrats.webp`} className="w-full" />,
        description: <></>
      },
      lose: {
        button: {
          text: 'Ir al rock id',
          url: '/profile/identificacion'
        },
        title: <img src={`${AZURE_BASE_URL}/bad-prize-congrats.webp`} className="w-full" />,
        description: <></>
      }
    }
  }
}
